import CircularProgress from '@zeptonow/zui/CircularProgress';
import MainLayout from '@zeptonow/zui/MainLayout';
import { Fragment, useEffect } from 'react';
import Header from '../components/header';
import SideBar from '../components/side-bar';
import AppRoutes from '../routes';
import { RoleConfigStore, UserStore } from '../store';
import ContainerLayout from './ContainerLayout';

import { handleSetEntityName } from '../auth/utils';
import StatusConfigStore from '../store/statusConfigStore';
import StoreConfigStore from '../store/storeConfig';
import { generateImage } from '../utilities/utils';
import {
  handleSetStatusConfig,
  handleSetStoreConfig,
  handleUpdateUserProfile,
} from './utilities';

const Layout: React.FC = () => {
  const isLoggedIn = UserStore((state) => state.isLoggedIn);
  const user = UserStore((state) => state);
  const setProfile = UserStore((state) => state.setUserProfile);
  const setStatusConfig = StatusConfigStore((state) => state.setStatusConfig);
  const setStoreConfig = StoreConfigStore((state) => state.setStoreConfig);
  const setRoleConfig = RoleConfigStore((state) => state.setRoleConfig);
  const setRoleConfigTags = RoleConfigStore((state) => state.setRoleConfigTags);
  const setRoleConfigActions = RoleConfigStore(
    (state) => state.setRoleConfigActions
  );
  const entityCodesList = UserStore((state) => state.entityCodesList);
  const isEntitySelected = UserStore((state) => !!state.entityCode);

  useEffect(() => {
    if (isLoggedIn) {
      handleUpdateUserProfile({
        setProfile,
        isLoggedIn,
      });

      handleSetEntityName(
        // setEntityData,
        // setBrandsList,
        setRoleConfig,
        setRoleConfigTags,
        setRoleConfigActions
      );
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn && isEntitySelected) {
      handleSetStatusConfig(setStatusConfig);
      handleSetStoreConfig(setStoreConfig);
    }
  }, [isLoggedIn, isEntitySelected]);

  if (!isLoggedIn || !Array.isArray(entityCodesList)) {
    return (
      <Fragment>
        <AppRoutes />
        <ContainerLayout />
      </Fragment>
    );
  }

  if (!user) {
    return <CircularProgress isOpen={true} color="primary.700" />;
  }

  return (
    <div>
      <MainLayout>
        {/* SIDEBAR */}
        <MainLayout.Aside
          logo={generateImage({
            name: 'zepto-icon',
            alt: 'zepto icon',
            className: 'w-8 h-8',
          })}
        >
          <SideBar />
        </MainLayout.Aside>

        <MainLayout.Nav>
          <Header />
        </MainLayout.Nav>

        <MainLayout.Main>
          <div className="bg-gray-100 h-full">
            <AppRoutes />
          </div>
        </MainLayout.Main>

        <ContainerLayout />
      </MainLayout>
    </div>
  );
};

export default Layout;
